// Shared page-shell metrics so the Topbar and every page (via MainLayout's
// <Outlet />) align to the same centered, max-width container with consistent
// side gutters. Change here to re-space the whole app at once.
//
// maxWidth caps content on large screens (centered via mx: 'auto'); below that
// breakpoint the page is fluid full-width minus the responsive PAGE_PX gutters.
export const PAGE_MAX_WIDTH = '1728px';

// Side gutters scale with the viewport: tight on phones, roomier on desktops.
export const PAGE_PX = { xs: '12px', sm: '16px', md: '24px', lg: '32px' } as const;

// Fixed Topbar height — MainLayout's <main> top padding must stay in lockstep
// with this so page content never overlaps or gaps under the fixed Topbar.
export const TOPBAR_HEIGHT = '68px';
